import Dialog from "components/ui/Dialog/Dialog";
import Loader from "components/ui/Loader/Loader";
import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useState } from "react";
import { useDialog } from "context/DialogContext";
import Textarea from "components/form/Textarea/Textarea";
import { useGroupAccess } from "features/groups/hooks/useGroupAccess";
import PropTypes from "prop-types";
import Alert from "components/ui/Alert/Alert";

const GroupMemberRequestAccessDialog = ({ groupId, groupMemberId, onCompleted }) => {
  const [ motivation, setMotivation ] = useState('');
  const [ error, setError ] = useState();
  const { hideDialog } = useDialog();
  const { working, requestAccess } = useGroupAccess();

  const onConfirm = async () => {
    setError(null);

    if (!motivation) {
      setError('U dient een motivatie op te geven om toegang aan te vragen.');
      return;
    }

    const response = await requestAccess(groupId, groupMemberId, motivation);
    if (response?.status === 409) {
      setError('U heeft al toegang aanvraagd voor deze groep.');
      return;
    }

    if (!response?.ok) {
      setError('Er ging iets mis bij uw aanvraag, probeer het later opnieuw.');
      return;
    }

    const result = await response.json();

    onCompleted(result);
    hideDialog();
  }

  let content =
    <>
      { error && <Alert message={ error } /> }
      <div className={ `dialog__row` }>
        <h3><Trans text={ `Om toegang te krijgen tot deze groep is goedkeuring van de beheerder vereist.` }/></h3>
      </div>

      <div className={ `dialog__row` }>
        <h3><Trans text={ `Waarom wilt u lid worden van deze groep?` }/></h3>
        <Textarea onChange={ event => setMotivation(event.target.value) } value={ motivation } autoFocus/>
      </div>

      <div className="dialog__buttons">
        <Button variant={ `ghost` } onClick={ () => hideDialog() }>Annuleren</Button>
        <Button variant={ `secondary` } onClick={ onConfirm }>Toegang aanvragen</Button>
      </div>
    </>;

  if (working) {
    content = <Loader/>;
  }

  return (
    <Dialog title={ `Toegangscontrole` }>
      { content }
    </Dialog>
  );
}

GroupMemberRequestAccessDialog.propTypes = {
  groupId: PropTypes.number.isRequired,
  onCompleted: PropTypes.func.isRequired
}

export default GroupMemberRequestAccessDialog;
